/**
 * Sticky function for breadcrumbs
 */

var debounce = require('modules/debounce')
module.exports = function () {
  var sticky = function () {
    if ($(window).scrollTop() >= 200) {
      $('body').addClass('breadcrumb_sticky')
    } else {
      $('body').removeClass('breadcrumb_sticky')
    }
  }
  $(window).scroll(debounce(sticky, 20))
}
